"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AxiosRestClient = void 0;

var axios_1 = require("axios");

var AxiosRestClient =
/** @class */
function () {
  function AxiosRestClient(basePath, interceptor) {
    this.basePath = basePath;
    this.interceptor = interceptor;
    this.axiosInstance = axios_1.default.create({
      withCredentials: true,
      baseURL: this.basePath // Replace with your API base URL

    }); // Add interceptor

    if (this.interceptor) {
      this.axiosInstance.interceptors.request.use(this.interceptor);
    }
  }

  AxiosRestClient.prototype.get = function (path, queryParameters, headers, options, timeoutSeconds) {
    return this.axiosInstance({
      method: 'GET',
      url: this.makeUrl(path),
      headers: headers,
      params: queryParameters
    });
  };

  AxiosRestClient.prototype.post = function (path, formParameters, headers, options, timeoutSeconds) {
    return this.axiosInstance({
      method: 'POST',
      url: this.makeUrl(path),
      data: formParameters,
      headers: headers
    });
  };

  AxiosRestClient.prototype.postMultipart = function (path, formParameters, headers, options, timeoutSeconds) {
    throw Error('Implement Post Multipart');
  };

  AxiosRestClient.prototype.makeUrl = function (path) {
    return this.basePath + '/' + path;
  };

  return AxiosRestClient;
}();

exports.AxiosRestClient = AxiosRestClient;